import { AuthService } from 'services/auth.service';
import { Component } from '@angular/core';

@Component({ template: '' })
export class LogOutComponent {
  constructor(private authService: AuthService) {
    void this.authService.logout();
  }
}
